/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:18e7cfa7-e7fa-4302-b584-84f967358862",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_DIO4nb4Pa",
    "aws_user_pools_web_client_id": "5m8l0hctlu1hdbo6p9e7btrb5s",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "mys3bucket131753-default",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
